import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/about/team/pageContext';

export const TeamErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for About/Team page (error: ${error})`);
};
